import { useTranslation } from "react-i18next";
import InfoLayout from "./InfoLayout";
import "../../styles/InfoPage.css";

export default function PrivacyPage() {
  const { t } = useTranslation("privacy");

  return (
    <InfoLayout title={t("title")}>
      <h2 className="infoH2">{t("heading1")}</h2>
      <p className="infoP">{t("text1")}</p>

      <h2 className="infoH2">{t("heading2")}</h2>
      <p className="infoP">{t("text2")}</p>

      <h2 className="infoH2">{t("heading3")}</h2>
      <p className="infoP">{t("text3")}</p>

      <p className="infoP">{t("text4")}</p>
    </InfoLayout>
  );
}